<template>
    <div class="h-100 d-flex flex-column">
        <div class="d-flex align-self-center mt-auto mb-auto">
            <i class="fas fa-spinner fa-spin" style="font-size: 80px"></i>
        </div>
    </div>
</template>

<script lang="ts">
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Login from './Login.vue'
import CredentialsStore from '../store/credentials-store'

@Component({ store: CredentialsStore, components: { Login } })
export default class Loading extends mixins(LysiasApiMixin)
{
}
</script>
